export default __webpack_public_path__ + "static/media/contact_bg_zoushi.bdb013e8.jpg";